/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const dbAddItem = /* GraphQL */ `
  mutation DbAddItem($db: String!, $dbItem: AWSJSON!) {
    dbAddItem(db: $db, dbItem: $dbItem) {
      statusState
      statusMessage
      statusItem
      __typename
    }
  }
`;
export const dbDeleteItem = /* GraphQL */ `
  mutation DbDeleteItem($db: String!, $dbItemId: String!, $dbItem: AWSJSON) {
    dbDeleteItem(db: $db, dbItemId: $dbItemId, dbItem: $dbItem) {
      statusState
      statusMessage
      statusItem
      __typename
    }
  }
`;
export const dbEditItem = /* GraphQL */ `
  mutation DbEditItem($db: String!, $dbItemId: String!, $dbItem: AWSJSON!) {
    dbEditItem(db: $db, dbItemId: $dbItemId, dbItem: $dbItem) {
      statusState
      statusMessage
      statusItem
      __typename
    }
  }
`;
export const createArea = /* GraphQL */ `
  mutation CreateArea(
    $areaName: String!
    $areaManager: String!
    $areaType: String!
  ) {
    createArea(
      areaName: $areaName
      areaManager: $areaManager
      areaType: $areaType
    ) {
      areaId
      areaName
      areaManager
      areaType
      stores {
        storeId
        shortName
        longName
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        gm
        status
        type
        compStores {
          storeId
          shortName
          __typename
        }
        thresholds {
          avgCheck
          netSales
          splhTotal
          splhFOH
          splhBOH
          __typename
        }
        toastId
        __typename
      }
      __typename
    }
  }
`;
export const createCognitoUser = /* GraphQL */ `
  mutation CreateCognitoUser(
    $userPool: String!
    $userName: String!
    $email: String
    $tempPassword: String
  ) {
    createCognitoUser(
      userPool: $userPool
      userName: $userName
      email: $email
      tempPassword: $tempPassword
    ) {
      email
      userName
      __typename
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $clientId: String!
    $note: String!
    $status: String!
    $position: Int!
  ) {
    createMessage(
      clientId: $clientId
      note: $note
      status: $status
      position: $position
    ) {
      messageId
      note
      status
      position
      createdAt
      __typename
    }
  }
`;
export const createPriceIncrease = /* GraphQL */ `
  mutation CreatePriceIncrease(
    $client: String!
    $year: String!
    $priceIncrease: Int!
  ) {
    createPriceIncrease(
      client: $client
      year: $year
      priceIncrease: $priceIncrease
    ) {
      year
      amount
      __typename
    }
  }
`;
export const createRole = /* GraphQL */ `
  mutation CreateRole(
    $clientId: String!
    $role: String!
    $description: String!
  ) {
    createRole(clientId: $clientId, role: $role, description: $description) {
      clientId
      role
      description
      __typename
    }
  }
`;
export const createR0003Projection = /* GraphQL */ `
  mutation CreateR0003Projection($input: R0003ProjectionInput) {
    createR0003Projection(input: $input) {
      week
      store
      avgWage
      monProjSales
      monProjAvgCheck
      monSchedFOH
      monSchedBOH
      tueProjSales
      tueProjAvgCheck
      tueSchedFOH
      tueSchedBOH
      wedProjSales
      wedProjAvgCheck
      wedSchedFOH
      wedSchedBOH
      thuProjSales
      thuProjAvgCheck
      thuSchedFOH
      thuSchedBOH
      friProjSales
      friProjAvgCheck
      friSchedFOH
      friSchedBOH
      satProjSales
      satProjAvgCheck
      satSchedFOH
      satSchedBOH
      sunProjSales
      sunProjAvgCheck
      sunSchedFOH
      sunSchedBOH
      __typename
    }
  }
`;
export const createR0003StoreNotes = /* GraphQL */ `
  mutation CreateR0003StoreNotes($input: R0003StoreNotesInput) {
    createR0003StoreNotes(input: $input) {
      week
      store
      notes {
        monNotes
        tueNotes
        wedNotes
        thuNotes
        friNotes
        satNotes
        sunNotes
        __typename
      }
      __typename
    }
  }
`;
export const createStore = /* GraphQL */ `
  mutation CreateStore($input: CreateStoreInput) {
    createStore(input: $input) {
      storeId
      shortName
      longName
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      gm
      status
      type
      compStores {
        storeId
        shortName
        __typename
      }
      thresholds {
        avgCheck
        netSales
        splhTotal
        splhFOH
        splhBOH
        __typename
      }
      toastId
      __typename
    }
  }
`;
export const deleteArea = /* GraphQL */ `
  mutation DeleteArea($areaId: String!) {
    deleteArea(areaId: $areaId) {
      areaId
      areaName
      areaManager
      areaType
      stores {
        storeId
        shortName
        longName
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        gm
        status
        type
        compStores {
          storeId
          shortName
          __typename
        }
        thresholds {
          avgCheck
          netSales
          splhTotal
          splhFOH
          splhBOH
          __typename
        }
        toastId
        __typename
      }
      __typename
    }
  }
`;
export const deleteCognitoUser = /* GraphQL */ `
  mutation DeleteCognitoUser($userPool: String!, $userName: String!) {
    deleteCognitoUser(userPool: $userPool, userName: $userName)
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage($clientId: String!, $messageId: String!) {
    deleteMessage(clientId: $clientId, messageId: $messageId) {
      messageId
      note
      status
      position
      createdAt
      __typename
    }
  }
`;
export const deletePriceIncrease = /* GraphQL */ `
  mutation DeletePriceIncrease($client: String!, $year: String!) {
    deletePriceIncrease(client: $client, year: $year) {
      year
      amount
      __typename
    }
  }
`;
export const deleteRole = /* GraphQL */ `
  mutation DeleteRole($clientId: String!, $role: String!) {
    deleteRole(clientId: $clientId, role: $role) {
      clientId
      role
      description
      __typename
    }
  }
`;
export const deleteStore = /* GraphQL */ `
  mutation DeleteStore($areaId: String!, $storeId: String!) {
    deleteStore(areaId: $areaId, storeId: $storeId) {
      storeId
      shortName
      longName
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      gm
      status
      type
      compStores {
        storeId
        shortName
        __typename
      }
      thresholds {
        avgCheck
        netSales
        splhTotal
        splhFOH
        splhBOH
        __typename
      }
      toastId
      __typename
    }
  }
`;
export const updateArea = /* GraphQL */ `
  mutation UpdateArea(
    $areaId: String!
    $areaName: String
    $areaManager: String
    $areaType: String
  ) {
    updateArea(
      areaId: $areaId
      areaName: $areaName
      areaManager: $areaManager
      areaType: $areaType
    ) {
      areaId
      areaName
      areaManager
      areaType
      stores {
        storeId
        shortName
        longName
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        gm
        status
        type
        compStores {
          storeId
          shortName
          __typename
        }
        thresholds {
          avgCheck
          netSales
          splhTotal
          splhFOH
          splhBOH
          __typename
        }
        toastId
        __typename
      }
      __typename
    }
  }
`;
export const updateCognitoUser = /* GraphQL */ `
  mutation UpdateCognitoUser(
    $userPool: String!
    $userName: String!
    $email: String
  ) {
    updateCognitoUser(userPool: $userPool, userName: $userName, email: $email) {
      email
      userName
      __typename
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $clientId: String!
    $messageId: String!
    $note: String
    $status: String
    $position: Float
  ) {
    updateMessage(
      clientId: $clientId
      messageId: $messageId
      note: $note
      status: $status
      position: $position
    ) {
      messageId
      note
      status
      position
      createdAt
      __typename
    }
  }
`;
export const updatePriceIncrease = /* GraphQL */ `
  mutation UpdatePriceIncrease(
    $client: String!
    $year: String!
    $priceIncrease: Int!
  ) {
    updatePriceIncrease(
      client: $client
      year: $year
      priceIncrease: $priceIncrease
    ) {
      year
      amount
      __typename
    }
  }
`;
export const updateR0003Projection = /* GraphQL */ `
  mutation UpdateR0003Projection($input: R0003ProjectionInput) {
    updateR0003Projection(input: $input) {
      week
      store
      avgWage
      monProjSales
      monProjAvgCheck
      monSchedFOH
      monSchedBOH
      tueProjSales
      tueProjAvgCheck
      tueSchedFOH
      tueSchedBOH
      wedProjSales
      wedProjAvgCheck
      wedSchedFOH
      wedSchedBOH
      thuProjSales
      thuProjAvgCheck
      thuSchedFOH
      thuSchedBOH
      friProjSales
      friProjAvgCheck
      friSchedFOH
      friSchedBOH
      satProjSales
      satProjAvgCheck
      satSchedFOH
      satSchedBOH
      sunProjSales
      sunProjAvgCheck
      sunSchedFOH
      sunSchedBOH
      __typename
    }
  }
`;
export const updateRole = /* GraphQL */ `
  mutation UpdateRole(
    $clientId: String!
    $role: String!
    $newRole: String
    $description: String
  ) {
    updateRole(
      clientId: $clientId
      role: $role
      newRole: $newRole
      description: $description
    ) {
      clientId
      role
      description
      __typename
    }
  }
`;
export const updateStore = /* GraphQL */ `
  mutation UpdateStore($input: UpdateStoreInput) {
    updateStore(input: $input) {
      storeId
      shortName
      longName
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      gm
      status
      type
      compStores {
        storeId
        shortName
        __typename
      }
      thresholds {
        avgCheck
        netSales
        splhTotal
        splhFOH
        splhBOH
        __typename
      }
      toastId
      __typename
    }
  }
`;
export const permBatchCreateGrants = /* GraphQL */ `
  mutation PermBatchCreateGrants(
    $grants: [CreateGrantInput!]!
    $skipValidation: Boolean
    $triggerRecalculation: Boolean
  ) {
    permBatchCreateGrants(
      grants: $grants
      skipValidation: $skipValidation
      triggerRecalculation: $triggerRecalculation
    ) {
      success
      created {
        id
        clientId
        name
        description
        targetDomain
        targetResourceTypeId
        targetResourceId
        targetResourcePattern
        subjectType
        subjectValue
        actionConfigs {
          action
          effect
          scopeConfig {
            includeChildren
            includePeers
            includeParent
            __typename
          }
          constraints
          priority
          __typename
        }
        priority
        constraints
        effectiveFrom
        effectiveTo
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
        grantSignature
        __typename
      }
      failed
      affectedUsers
      recalculationTriggered
      error
      __typename
    }
  }
`;
export const permRecalculateUserPermissions = /* GraphQL */ `
  mutation PermRecalculateUserPermissions(
    $userId: ID
    $grantId: ID
    $clientId: ID
    $action: String
    $source: String
  ) {
    permRecalculateUserPermissions(
      userId: $userId
      grantId: $grantId
      clientId: $clientId
      action: $action
      source: $source
    ) {
      success
      userId
      grantId
      clientId
      affectedUsers
      permissions
      navigation
      dataScope
      cacheUpdated
      calculatedAt
      error
      errorType
      errorCode
      statusCode
      __typename
    }
  }
`;
export const permBumpSecurityVersion = /* GraphQL */ `
  mutation PermBumpSecurityVersion(
    $userId: ID
    $clientId: ID
    $allUsersInClient: Boolean
    $reason: String
    $triggerRecalculation: Boolean
  ) {
    permBumpSecurityVersion(
      userId: $userId
      clientId: $clientId
      allUsersInClient: $allUsersInClient
      reason: $reason
      triggerRecalculation: $triggerRecalculation
    ) {
      success
      userId
      clientId
      previousVersion
      newVersion
      totalUsers
      successfulUpdates
      failedUpdates
      reason
      cacheInvalidated
      recalculationTriggered
      error
      __typename
    }
  }
`;
export const seedDemoConfig = /* GraphQL */ `
  mutation SeedDemoConfig($clientId: String!) {
    seedDemoConfig(clientId: $clientId)
  }
`;
export const startDemoRun = /* GraphQL */ `
  mutation StartDemoRun($input: DemoRunInput!) {
    startDemoRun(input: $input) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const purgeDemoData = /* GraphQL */ `
  mutation PurgeDemoData($scope: DemoScopeInput!) {
    purgeDemoData(scope: $scope) {
      atomic
      __typename
    }
  }
`;
export const createClient = /* GraphQL */ `
  mutation CreateClient(
    $input: CreateClientInput!
    $condition: ModelClientConditionInput
  ) {
    createClient(input: $input, condition: $condition) {
      id
      clientId
      clientName
      contactName
      contactPhone
      contactEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateClient = /* GraphQL */ `
  mutation UpdateClient(
    $input: UpdateClientInput!
    $condition: ModelClientConditionInput
  ) {
    updateClient(input: $input, condition: $condition) {
      id
      clientId
      clientName
      contactName
      contactPhone
      contactEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteClient = /* GraphQL */ `
  mutation DeleteClient(
    $input: DeleteClientInput!
    $condition: ModelClientConditionInput
  ) {
    deleteClient(input: $input, condition: $condition) {
      id
      clientId
      clientName
      contactName
      contactPhone
      contactEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createForecastedSales = /* GraphQL */ `
  mutation CreateForecastedSales(
    $input: CreateForecastedSalesInput!
    $condition: ModelForecastedSalesConditionInput
  ) {
    createForecastedSales(input: $input, condition: $condition) {
      id
      storeName
      date
      forecastedSales
      storeId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateForecastedSales = /* GraphQL */ `
  mutation UpdateForecastedSales(
    $input: UpdateForecastedSalesInput!
    $condition: ModelForecastedSalesConditionInput
  ) {
    updateForecastedSales(input: $input, condition: $condition) {
      id
      storeName
      date
      forecastedSales
      storeId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteForecastedSales = /* GraphQL */ `
  mutation DeleteForecastedSales(
    $input: DeleteForecastedSalesInput!
    $condition: ModelForecastedSalesConditionInput
  ) {
    deleteForecastedSales(input: $input, condition: $condition) {
      id
      storeName
      date
      forecastedSales
      storeId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHierarchyDefinition = /* GraphQL */ `
  mutation CreateHierarchyDefinition(
    $input: CreateHierarchyDefinitionInput!
    $condition: ModelHierarchyDefinitionConditionInput
  ) {
    createHierarchyDefinition(input: $input, condition: $condition) {
      id
      clientId
      version
      effectiveDate
      endDate
      levels {
        levelId
        label
        order
        isUsed
        introducedInVersion
        __typename
      }
      changeReason
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const updateHierarchyDefinition = /* GraphQL */ `
  mutation UpdateHierarchyDefinition(
    $input: UpdateHierarchyDefinitionInput!
    $condition: ModelHierarchyDefinitionConditionInput
  ) {
    updateHierarchyDefinition(input: $input, condition: $condition) {
      id
      clientId
      version
      effectiveDate
      endDate
      levels {
        levelId
        label
        order
        isUsed
        introducedInVersion
        __typename
      }
      changeReason
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const deleteHierarchyDefinition = /* GraphQL */ `
  mutation DeleteHierarchyDefinition(
    $input: DeleteHierarchyDefinitionInput!
    $condition: ModelHierarchyDefinitionConditionInput
  ) {
    deleteHierarchyDefinition(input: $input, condition: $condition) {
      id
      clientId
      version
      effectiveDate
      endDate
      levels {
        levelId
        label
        order
        isUsed
        introducedInVersion
        __typename
      }
      changeReason
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const createOrgUnit = /* GraphQL */ `
  mutation CreateOrgUnit(
    $input: CreateOrgUnitInput!
    $condition: ModelOrgUnitConditionInput
  ) {
    createOrgUnit(input: $input, condition: $condition) {
      id
      clientId
      orgLevel
      name
      isActive
      sortOrder
      parentOrgUnitId
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrgUnit = /* GraphQL */ `
  mutation UpdateOrgUnit(
    $input: UpdateOrgUnitInput!
    $condition: ModelOrgUnitConditionInput
  ) {
    updateOrgUnit(input: $input, condition: $condition) {
      id
      clientId
      orgLevel
      name
      isActive
      sortOrder
      parentOrgUnitId
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgUnit = /* GraphQL */ `
  mutation DeleteOrgUnit(
    $input: DeleteOrgUnitInput!
    $condition: ModelOrgUnitConditionInput
  ) {
    deleteOrgUnit(input: $input, condition: $condition) {
      id
      clientId
      orgLevel
      name
      isActive
      sortOrder
      parentOrgUnitId
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStoreRecord = /* GraphQL */ `
  mutation CreateStoreRecord(
    $input: CreateStoreRecordInput!
    $condition: ModelStoreRecordConditionInput
  ) {
    createStoreRecord(input: $input, condition: $condition) {
      id
      clientId
      storeId
      storeName
      storeNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      toastId
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      managerUserIds
      ownershipType
      conceptId
      tags
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStoreRecord = /* GraphQL */ `
  mutation UpdateStoreRecord(
    $input: UpdateStoreRecordInput!
    $condition: ModelStoreRecordConditionInput
  ) {
    updateStoreRecord(input: $input, condition: $condition) {
      id
      clientId
      storeId
      storeName
      storeNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      toastId
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      managerUserIds
      ownershipType
      conceptId
      tags
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStoreRecord = /* GraphQL */ `
  mutation DeleteStoreRecord(
    $input: DeleteStoreRecordInput!
    $condition: ModelStoreRecordConditionInput
  ) {
    deleteStoreRecord(input: $input, condition: $condition) {
      id
      clientId
      storeId
      storeName
      storeNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      toastId
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      managerUserIds
      ownershipType
      conceptId
      tags
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      clientId
      locationName
      locationNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      ownershipType
      conceptId
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      clientId
      locationName
      locationNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      ownershipType
      conceptId
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      clientId
      locationName
      locationNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      ownershipType
      conceptId
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLocationLaborTargets = /* GraphQL */ `
  mutation CreateLocationLaborTargets(
    $input: CreateLocationLaborTargetsInput!
    $condition: ModelLocationLaborTargetsConditionInput
  ) {
    createLocationLaborTargets(input: $input, condition: $condition) {
      id
      clientId
      locationId
      fohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      fohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      effectiveDate
      endDate
      isActive
      reason
      reasonType
      supersedes
      supersededBy
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const updateLocationLaborTargets = /* GraphQL */ `
  mutation UpdateLocationLaborTargets(
    $input: UpdateLocationLaborTargetsInput!
    $condition: ModelLocationLaborTargetsConditionInput
  ) {
    updateLocationLaborTargets(input: $input, condition: $condition) {
      id
      clientId
      locationId
      fohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      fohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      effectiveDate
      endDate
      isActive
      reason
      reasonType
      supersedes
      supersededBy
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const deleteLocationLaborTargets = /* GraphQL */ `
  mutation DeleteLocationLaborTargets(
    $input: DeleteLocationLaborTargetsInput!
    $condition: ModelLocationLaborTargetsConditionInput
  ) {
    deleteLocationLaborTargets(input: $input, condition: $condition) {
      id
      clientId
      locationId
      fohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      fohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      effectiveDate
      endDate
      isActive
      reason
      reasonType
      supersedes
      supersededBy
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const createRoleDefinition = /* GraphQL */ `
  mutation CreateRoleDefinition(
    $input: CreateRoleDefinitionInput!
    $condition: ModelRoleDefinitionConditionInput
  ) {
    createRoleDefinition(input: $input, condition: $condition) {
      id
      clientId
      roleName
      roleCode
      assignmentLevel
      category
      sortOrder
      isActive
      isDefault
      metadata
      createdBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const updateRoleDefinition = /* GraphQL */ `
  mutation UpdateRoleDefinition(
    $input: UpdateRoleDefinitionInput!
    $condition: ModelRoleDefinitionConditionInput
  ) {
    updateRoleDefinition(input: $input, condition: $condition) {
      id
      clientId
      roleName
      roleCode
      assignmentLevel
      category
      sortOrder
      isActive
      isDefault
      metadata
      createdBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const deleteRoleDefinition = /* GraphQL */ `
  mutation DeleteRoleDefinition(
    $input: DeleteRoleDefinitionInput!
    $condition: ModelRoleDefinitionConditionInput
  ) {
    deleteRoleDefinition(input: $input, condition: $condition) {
      id
      clientId
      roleName
      roleCode
      assignmentLevel
      category
      sortOrder
      isActive
      isDefault
      metadata
      createdBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const createEmployee = /* GraphQL */ `
  mutation CreateEmployee(
    $input: CreateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    createEmployee(input: $input, condition: $condition) {
      id
      clientId
      firstName
      lastName
      email
      phoneNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      isActive
      employmentType
      hireDate
      terminationDate
      userId
      tags
      metadata
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const updateEmployee = /* GraphQL */ `
  mutation UpdateEmployee(
    $input: UpdateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    updateEmployee(input: $input, condition: $condition) {
      id
      clientId
      firstName
      lastName
      email
      phoneNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      isActive
      employmentType
      hireDate
      terminationDate
      userId
      tags
      metadata
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const deleteEmployee = /* GraphQL */ `
  mutation DeleteEmployee(
    $input: DeleteEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    deleteEmployee(input: $input, condition: $condition) {
      id
      clientId
      firstName
      lastName
      email
      phoneNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      isActive
      employmentType
      hireDate
      terminationDate
      userId
      tags
      metadata
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const createLocationEmployee = /* GraphQL */ `
  mutation CreateLocationEmployee(
    $input: CreateLocationEmployeeInput!
    $condition: ModelLocationEmployeeConditionInput
  ) {
    createLocationEmployee(input: $input, condition: $condition) {
      id
      clientId
      employeeId
      locationId
      roleDefinitionId
      isPrimary
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      locationNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const updateLocationEmployee = /* GraphQL */ `
  mutation UpdateLocationEmployee(
    $input: UpdateLocationEmployeeInput!
    $condition: ModelLocationEmployeeConditionInput
  ) {
    updateLocationEmployee(input: $input, condition: $condition) {
      id
      clientId
      employeeId
      locationId
      roleDefinitionId
      isPrimary
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      locationNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const deleteLocationEmployee = /* GraphQL */ `
  mutation DeleteLocationEmployee(
    $input: DeleteLocationEmployeeInput!
    $condition: ModelLocationEmployeeConditionInput
  ) {
    deleteLocationEmployee(input: $input, condition: $condition) {
      id
      clientId
      employeeId
      locationId
      roleDefinitionId
      isPrimary
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      locationNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const createOrgUnitEmployee = /* GraphQL */ `
  mutation CreateOrgUnitEmployee(
    $input: CreateOrgUnitEmployeeInput!
    $condition: ModelOrgUnitEmployeeConditionInput
  ) {
    createOrgUnitEmployee(input: $input, condition: $condition) {
      id
      clientId
      employeeId
      orgUnitId
      managementLevel
      roleDefinitionId
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      orgUnitNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const updateOrgUnitEmployee = /* GraphQL */ `
  mutation UpdateOrgUnitEmployee(
    $input: UpdateOrgUnitEmployeeInput!
    $condition: ModelOrgUnitEmployeeConditionInput
  ) {
    updateOrgUnitEmployee(input: $input, condition: $condition) {
      id
      clientId
      employeeId
      orgUnitId
      managementLevel
      roleDefinitionId
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      orgUnitNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgUnitEmployee = /* GraphQL */ `
  mutation DeleteOrgUnitEmployee(
    $input: DeleteOrgUnitEmployeeInput!
    $condition: ModelOrgUnitEmployeeConditionInput
  ) {
    deleteOrgUnitEmployee(input: $input, condition: $condition) {
      id
      clientId
      employeeId
      orgUnitId
      managementLevel
      roleDefinitionId
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      orgUnitNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const createBulkOperation = /* GraphQL */ `
  mutation CreateBulkOperation(
    $input: CreateBulkOperationInput!
    $condition: ModelBulkOperationConditionInput
  ) {
    createBulkOperation(input: $input, condition: $condition) {
      id
      clientId
      operationType
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercent
      errorSummary
      errorDetails
      operationData
      previewData
      canUndo
      undoOperationId
      undoReason
      initiatedBy
      initiatedByName
      startedAt
      estimatedCompletion
      completedAt
      notificationsSent
      completionEmailSent
      description
      changeReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBulkOperation = /* GraphQL */ `
  mutation UpdateBulkOperation(
    $input: UpdateBulkOperationInput!
    $condition: ModelBulkOperationConditionInput
  ) {
    updateBulkOperation(input: $input, condition: $condition) {
      id
      clientId
      operationType
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercent
      errorSummary
      errorDetails
      operationData
      previewData
      canUndo
      undoOperationId
      undoReason
      initiatedBy
      initiatedByName
      startedAt
      estimatedCompletion
      completedAt
      notificationsSent
      completionEmailSent
      description
      changeReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBulkOperation = /* GraphQL */ `
  mutation DeleteBulkOperation(
    $input: DeleteBulkOperationInput!
    $condition: ModelBulkOperationConditionInput
  ) {
    deleteBulkOperation(input: $input, condition: $condition) {
      id
      clientId
      operationType
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercent
      errorSummary
      errorDetails
      operationData
      previewData
      canUndo
      undoOperationId
      undoReason
      initiatedBy
      initiatedByName
      startedAt
      estimatedCompletion
      completedAt
      notificationsSent
      completionEmailSent
      description
      changeReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHierarchyChangeLog = /* GraphQL */ `
  mutation CreateHierarchyChangeLog(
    $input: CreateHierarchyChangeLogInput!
    $condition: ModelHierarchyChangeLogConditionInput
  ) {
    createHierarchyChangeLog(input: $input, condition: $condition) {
      id
      clientId
      changeType
      affectedLocations
      affectedOrgUnits
      changeDetails {
        entityType
        entityId
        entityName
        operationType
        fieldChanges {
          fieldName
          oldValue
          oldDisplayValue
          newValue
          newDisplayValue
          __typename
        }
        metadata
        __typename
      }
      changeSummary
      changeReason
      changedBy
      changedByName
      changedAt
      bulkOperationId
      snapshotId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHierarchyChangeLog = /* GraphQL */ `
  mutation UpdateHierarchyChangeLog(
    $input: UpdateHierarchyChangeLogInput!
    $condition: ModelHierarchyChangeLogConditionInput
  ) {
    updateHierarchyChangeLog(input: $input, condition: $condition) {
      id
      clientId
      changeType
      affectedLocations
      affectedOrgUnits
      changeDetails {
        entityType
        entityId
        entityName
        operationType
        fieldChanges {
          fieldName
          oldValue
          oldDisplayValue
          newValue
          newDisplayValue
          __typename
        }
        metadata
        __typename
      }
      changeSummary
      changeReason
      changedBy
      changedByName
      changedAt
      bulkOperationId
      snapshotId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHierarchyChangeLog = /* GraphQL */ `
  mutation DeleteHierarchyChangeLog(
    $input: DeleteHierarchyChangeLogInput!
    $condition: ModelHierarchyChangeLogConditionInput
  ) {
    deleteHierarchyChangeLog(input: $input, condition: $condition) {
      id
      clientId
      changeType
      affectedLocations
      affectedOrgUnits
      changeDetails {
        entityType
        entityId
        entityName
        operationType
        fieldChanges {
          fieldName
          oldValue
          oldDisplayValue
          newValue
          newDisplayValue
          __typename
        }
        metadata
        __typename
      }
      changeSummary
      changeReason
      changedBy
      changedByName
      changedAt
      bulkOperationId
      snapshotId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHierarchySnapshot = /* GraphQL */ `
  mutation CreateHierarchySnapshot(
    $input: CreateHierarchySnapshotInput!
    $condition: ModelHierarchySnapshotConditionInput
  ) {
    createHierarchySnapshot(input: $input, condition: $condition) {
      id
      clientId
      snapshotDate
      locations {
        locationId
        locationName
        orgLevel_1
        orgLevel_1_name
        orgLevel_2
        orgLevel_2_name
        orgLevel_3
        orgLevel_3_name
        laborTargets {
          fohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          bohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          fohVariableHours
          bohVariableHours
          salesBase
          effectiveDate
          __typename
        }
        isActive
        closeDate
        __typename
      }
      orgUnits {
        orgUnitId
        name
        orgLevel
        parentOrgUnitId
        parentOrgUnitName
        isActive
        __typename
      }
      hierarchyChangeLogId
      reason
      createdAt
      createdBy
      createdByName
      totalLocations
      totalOrgUnits
      snapshotType
      updatedAt
      __typename
    }
  }
`;
export const updateHierarchySnapshot = /* GraphQL */ `
  mutation UpdateHierarchySnapshot(
    $input: UpdateHierarchySnapshotInput!
    $condition: ModelHierarchySnapshotConditionInput
  ) {
    updateHierarchySnapshot(input: $input, condition: $condition) {
      id
      clientId
      snapshotDate
      locations {
        locationId
        locationName
        orgLevel_1
        orgLevel_1_name
        orgLevel_2
        orgLevel_2_name
        orgLevel_3
        orgLevel_3_name
        laborTargets {
          fohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          bohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          fohVariableHours
          bohVariableHours
          salesBase
          effectiveDate
          __typename
        }
        isActive
        closeDate
        __typename
      }
      orgUnits {
        orgUnitId
        name
        orgLevel
        parentOrgUnitId
        parentOrgUnitName
        isActive
        __typename
      }
      hierarchyChangeLogId
      reason
      createdAt
      createdBy
      createdByName
      totalLocations
      totalOrgUnits
      snapshotType
      updatedAt
      __typename
    }
  }
`;
export const deleteHierarchySnapshot = /* GraphQL */ `
  mutation DeleteHierarchySnapshot(
    $input: DeleteHierarchySnapshotInput!
    $condition: ModelHierarchySnapshotConditionInput
  ) {
    deleteHierarchySnapshot(input: $input, condition: $condition) {
      id
      clientId
      snapshotDate
      locations {
        locationId
        locationName
        orgLevel_1
        orgLevel_1_name
        orgLevel_2
        orgLevel_2_name
        orgLevel_3
        orgLevel_3_name
        laborTargets {
          fohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          bohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          fohVariableHours
          bohVariableHours
          salesBase
          effectiveDate
          __typename
        }
        isActive
        closeDate
        __typename
      }
      orgUnits {
        orgUnitId
        name
        orgLevel
        parentOrgUnitId
        parentOrgUnitName
        isActive
        __typename
      }
      hierarchyChangeLogId
      reason
      createdAt
      createdBy
      createdByName
      totalLocations
      totalOrgUnits
      snapshotType
      updatedAt
      __typename
    }
  }
`;
export const createHierarchyConstraint = /* GraphQL */ `
  mutation CreateHierarchyConstraint(
    $input: CreateHierarchyConstraintInput!
    $condition: ModelHierarchyConstraintConditionInput
  ) {
    createHierarchyConstraint(input: $input, condition: $condition) {
      id
      clientId
      constraintType
      config
      targetLevel
      isActive
      enforcement
      name
      description
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const updateHierarchyConstraint = /* GraphQL */ `
  mutation UpdateHierarchyConstraint(
    $input: UpdateHierarchyConstraintInput!
    $condition: ModelHierarchyConstraintConditionInput
  ) {
    updateHierarchyConstraint(input: $input, condition: $condition) {
      id
      clientId
      constraintType
      config
      targetLevel
      isActive
      enforcement
      name
      description
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const deleteHierarchyConstraint = /* GraphQL */ `
  mutation DeleteHierarchyConstraint(
    $input: DeleteHierarchyConstraintInput!
    $condition: ModelHierarchyConstraintConditionInput
  ) {
    deleteHierarchyConstraint(input: $input, condition: $condition) {
      id
      clientId
      constraintType
      config
      targetLevel
      isActive
      enforcement
      name
      description
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const createTagCatalog = /* GraphQL */ `
  mutation CreateTagCatalog(
    $input: CreateTagCatalogInput!
    $condition: ModelTagCatalogConditionInput
  ) {
    createTagCatalog(input: $input, condition: $condition) {
      id
      clientId
      applicableTypes
      category
      label
      value
      description
      isActive
      isSystem
      metadata
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const updateTagCatalog = /* GraphQL */ `
  mutation UpdateTagCatalog(
    $input: UpdateTagCatalogInput!
    $condition: ModelTagCatalogConditionInput
  ) {
    updateTagCatalog(input: $input, condition: $condition) {
      id
      clientId
      applicableTypes
      category
      label
      value
      description
      isActive
      isSystem
      metadata
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const deleteTagCatalog = /* GraphQL */ `
  mutation DeleteTagCatalog(
    $input: DeleteTagCatalogInput!
    $condition: ModelTagCatalogConditionInput
  ) {
    deleteTagCatalog(input: $input, condition: $condition) {
      id
      clientId
      applicableTypes
      category
      label
      value
      description
      isActive
      isSystem
      metadata
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const createTagAssignment = /* GraphQL */ `
  mutation CreateTagAssignment(
    $input: CreateTagAssignmentInput!
    $condition: ModelTagAssignmentConditionInput
  ) {
    createTagAssignment(input: $input, condition: $condition) {
      id
      clientId
      entityType
      entityId
      tagCatalogId
      tagLabel
      tagCategory
      assignedBy
      assignedAt
      isActive
      context
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTagAssignment = /* GraphQL */ `
  mutation UpdateTagAssignment(
    $input: UpdateTagAssignmentInput!
    $condition: ModelTagAssignmentConditionInput
  ) {
    updateTagAssignment(input: $input, condition: $condition) {
      id
      clientId
      entityType
      entityId
      tagCatalogId
      tagLabel
      tagCategory
      assignedBy
      assignedAt
      isActive
      context
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTagAssignment = /* GraphQL */ `
  mutation DeleteTagAssignment(
    $input: DeleteTagAssignmentInput!
    $condition: ModelTagAssignmentConditionInput
  ) {
    deleteTagAssignment(input: $input, condition: $condition) {
      id
      clientId
      entityType
      entityId
      tagCatalogId
      tagLabel
      tagCategory
      assignedBy
      assignedAt
      isActive
      context
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      client
      userName
      firstName
      lastName
      email
      role
      group
      groupRole
      employeeId
      status
      securityVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      client
      userName
      firstName
      lastName
      email
      role
      group
      groupRole
      employeeId
      status
      securityVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      client
      userName
      firstName
      lastName
      email
      role
      group
      groupRole
      employeeId
      status
      securityVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createResourceType = /* GraphQL */ `
  mutation CreateResourceType(
    $input: CreateResourceTypeInput!
    $condition: ModelResourceTypeConditionInput
  ) {
    createResourceType(input: $input, condition: $condition) {
      id
      name
      resourcePrefix
      icon
      description
      status
      domainRestrictions
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateResourceType = /* GraphQL */ `
  mutation UpdateResourceType(
    $input: UpdateResourceTypeInput!
    $condition: ModelResourceTypeConditionInput
  ) {
    updateResourceType(input: $input, condition: $condition) {
      id
      name
      resourcePrefix
      icon
      description
      status
      domainRestrictions
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteResourceType = /* GraphQL */ `
  mutation DeleteResourceType(
    $input: DeleteResourceTypeInput!
    $condition: ModelResourceTypeConditionInput
  ) {
    deleteResourceType(input: $input, condition: $condition) {
      id
      name
      resourcePrefix
      icon
      description
      status
      domainRestrictions
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createResourceCatalog = /* GraphQL */ `
  mutation CreateResourceCatalog(
    $input: CreateResourceCatalogInput!
    $condition: ModelResourceCatalogConditionInput
  ) {
    createResourceCatalog(input: $input, condition: $condition) {
      id
      resourceCode
      resourceTypeId
      domain
      name
      description
      icon
      route
      componentPath
      defaultActions
      status
      version
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateResourceCatalog = /* GraphQL */ `
  mutation UpdateResourceCatalog(
    $input: UpdateResourceCatalogInput!
    $condition: ModelResourceCatalogConditionInput
  ) {
    updateResourceCatalog(input: $input, condition: $condition) {
      id
      resourceCode
      resourceTypeId
      domain
      name
      description
      icon
      route
      componentPath
      defaultActions
      status
      version
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteResourceCatalog = /* GraphQL */ `
  mutation DeleteResourceCatalog(
    $input: DeleteResourceCatalogInput!
    $condition: ModelResourceCatalogConditionInput
  ) {
    deleteResourceCatalog(input: $input, condition: $condition) {
      id
      resourceCode
      resourceTypeId
      domain
      name
      description
      icon
      route
      componentPath
      defaultActions
      status
      version
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createClientResourceMap = /* GraphQL */ `
  mutation CreateClientResourceMap(
    $input: CreateClientResourceMapInput!
    $condition: ModelClientResourceMapConditionInput
  ) {
    createClientResourceMap(input: $input, condition: $condition) {
      id
      clientId
      resourceId
      isEnabled
      customLabel
      customTooltip
      customDescription
      customIcon
      allowedActionsOverride
      order
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateClientResourceMap = /* GraphQL */ `
  mutation UpdateClientResourceMap(
    $input: UpdateClientResourceMapInput!
    $condition: ModelClientResourceMapConditionInput
  ) {
    updateClientResourceMap(input: $input, condition: $condition) {
      id
      clientId
      resourceId
      isEnabled
      customLabel
      customTooltip
      customDescription
      customIcon
      allowedActionsOverride
      order
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteClientResourceMap = /* GraphQL */ `
  mutation DeleteClientResourceMap(
    $input: DeleteClientResourceMapInput!
    $condition: ModelClientResourceMapConditionInput
  ) {
    deleteClientResourceMap(input: $input, condition: $condition) {
      id
      clientId
      resourceId
      isEnabled
      customLabel
      customTooltip
      customDescription
      customIcon
      allowedActionsOverride
      order
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserEmployee = /* GraphQL */ `
  mutation CreateUserEmployee(
    $input: CreateUserEmployeeInput!
    $condition: ModelUserEmployeeConditionInput
  ) {
    createUserEmployee(input: $input, condition: $condition) {
      id
      userId
      employeeId
      client
      linkedAt
      linkedBy
      unlinkedAt
      unlinkedBy
      isActive
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserEmployee = /* GraphQL */ `
  mutation UpdateUserEmployee(
    $input: UpdateUserEmployeeInput!
    $condition: ModelUserEmployeeConditionInput
  ) {
    updateUserEmployee(input: $input, condition: $condition) {
      id
      userId
      employeeId
      client
      linkedAt
      linkedBy
      unlinkedAt
      unlinkedBy
      isActive
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserEmployee = /* GraphQL */ `
  mutation DeleteUserEmployee(
    $input: DeleteUserEmployeeInput!
    $condition: ModelUserEmployeeConditionInput
  ) {
    deleteUserEmployee(input: $input, condition: $condition) {
      id
      userId
      employeeId
      client
      linkedAt
      linkedBy
      unlinkedAt
      unlinkedBy
      isActive
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGrant = /* GraphQL */ `
  mutation CreateGrant(
    $input: CreateGrantInput!
    $condition: ModelGrantConditionInput
  ) {
    createGrant(input: $input, condition: $condition) {
      id
      clientId
      name
      description
      targetDomain
      targetResourceTypeId
      targetResourceId
      targetResourcePattern
      subjectType
      subjectValue
      actionConfigs {
        action
        effect
        scopeConfig {
          includeChildren
          includePeers
          includeParent
          __typename
        }
        constraints
        priority
        __typename
      }
      priority
      constraints
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      grantSignature
      __typename
    }
  }
`;
export const updateGrant = /* GraphQL */ `
  mutation UpdateGrant(
    $input: UpdateGrantInput!
    $condition: ModelGrantConditionInput
  ) {
    updateGrant(input: $input, condition: $condition) {
      id
      clientId
      name
      description
      targetDomain
      targetResourceTypeId
      targetResourceId
      targetResourcePattern
      subjectType
      subjectValue
      actionConfigs {
        action
        effect
        scopeConfig {
          includeChildren
          includePeers
          includeParent
          __typename
        }
        constraints
        priority
        __typename
      }
      priority
      constraints
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      grantSignature
      __typename
    }
  }
`;
export const deleteGrant = /* GraphQL */ `
  mutation DeleteGrant(
    $input: DeleteGrantInput!
    $condition: ModelGrantConditionInput
  ) {
    deleteGrant(input: $input, condition: $condition) {
      id
      clientId
      name
      description
      targetDomain
      targetResourceTypeId
      targetResourceId
      targetResourcePattern
      subjectType
      subjectValue
      actionConfigs {
        action
        effect
        scopeConfig {
          includeChildren
          includePeers
          includeParent
          __typename
        }
        constraints
        priority
        __typename
      }
      priority
      constraints
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      grantSignature
      __typename
    }
  }
`;
export const createUserPermissionsCache = /* GraphQL */ `
  mutation CreateUserPermissionsCache(
    $input: CreateUserPermissionsCacheInput!
    $condition: ModelUserPermissionsCacheConditionInput
  ) {
    createUserPermissionsCache(input: $input, condition: $condition) {
      id
      clientId
      userId
      group
      groupRole
      permissions
      navigation
      dataScope {
        scopeType
        assignedLocations
        assignedOrgUnits
        accessibleLocations
        accessibleOrgUnits
        includeChildren
        includePeers
        includeParent
        calculatedAt
        calculatedFrom
        __typename
      }
      version
      calculatedAt
      lastUsed
      securityVersion
      hash
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserPermissionsCache = /* GraphQL */ `
  mutation UpdateUserPermissionsCache(
    $input: UpdateUserPermissionsCacheInput!
    $condition: ModelUserPermissionsCacheConditionInput
  ) {
    updateUserPermissionsCache(input: $input, condition: $condition) {
      id
      clientId
      userId
      group
      groupRole
      permissions
      navigation
      dataScope {
        scopeType
        assignedLocations
        assignedOrgUnits
        accessibleLocations
        accessibleOrgUnits
        includeChildren
        includePeers
        includeParent
        calculatedAt
        calculatedFrom
        __typename
      }
      version
      calculatedAt
      lastUsed
      securityVersion
      hash
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserPermissionsCache = /* GraphQL */ `
  mutation DeleteUserPermissionsCache(
    $input: DeleteUserPermissionsCacheInput!
    $condition: ModelUserPermissionsCacheConditionInput
  ) {
    deleteUserPermissionsCache(input: $input, condition: $condition) {
      id
      clientId
      userId
      group
      groupRole
      permissions
      navigation
      dataScope {
        scopeType
        assignedLocations
        assignedOrgUnits
        accessibleLocations
        accessibleOrgUnits
        includeChildren
        includePeers
        includeParent
        calculatedAt
        calculatedFrom
        __typename
      }
      version
      calculatedAt
      lastUsed
      securityVersion
      hash
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMetricData = /* GraphQL */ `
  mutation CreateMetricData(
    $input: CreateMetricDataInput!
    $condition: ModelMetricDataConditionInput
  ) {
    createMetricData(input: $input, condition: $condition) {
      metricId
      clientId
      storeId
      date
      hour
      frequency
      metricName
      metricType
      numberValue
      stringValue
      booleanValue
      dayPart
      diningOption
      source
      timestamp
      unit
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMetricData = /* GraphQL */ `
  mutation UpdateMetricData(
    $input: UpdateMetricDataInput!
    $condition: ModelMetricDataConditionInput
  ) {
    updateMetricData(input: $input, condition: $condition) {
      metricId
      clientId
      storeId
      date
      hour
      frequency
      metricName
      metricType
      numberValue
      stringValue
      booleanValue
      dayPart
      diningOption
      source
      timestamp
      unit
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMetricData = /* GraphQL */ `
  mutation DeleteMetricData(
    $input: DeleteMetricDataInput!
    $condition: ModelMetricDataConditionInput
  ) {
    deleteMetricData(input: $input, condition: $condition) {
      metricId
      clientId
      storeId
      date
      hour
      frequency
      metricName
      metricType
      numberValue
      stringValue
      booleanValue
      dayPart
      diningOption
      source
      timestamp
      unit
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createThreshold = /* GraphQL */ `
  mutation CreateThreshold(
    $input: CreateThresholdInput!
    $condition: ModelThresholdConditionInput
  ) {
    createThreshold(input: $input, condition: $condition) {
      id
      clientId
      name
      entityType
      entityId
      metric
      thresholdType
      thresholdBands {
        position
        operator
        numberValue
        textValue
        backgroundColor
        color
        fontWeight
        fontStyle
        borderColor
        borderWidth
        icon
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateThreshold = /* GraphQL */ `
  mutation UpdateThreshold(
    $input: UpdateThresholdInput!
    $condition: ModelThresholdConditionInput
  ) {
    updateThreshold(input: $input, condition: $condition) {
      id
      clientId
      name
      entityType
      entityId
      metric
      thresholdType
      thresholdBands {
        position
        operator
        numberValue
        textValue
        backgroundColor
        color
        fontWeight
        fontStyle
        borderColor
        borderWidth
        icon
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteThreshold = /* GraphQL */ `
  mutation DeleteThreshold(
    $input: DeleteThresholdInput!
    $condition: ModelThresholdConditionInput
  ) {
    deleteThreshold(input: $input, condition: $condition) {
      id
      clientId
      name
      entityType
      entityId
      metric
      thresholdType
      thresholdBands {
        position
        operator
        numberValue
        textValue
        backgroundColor
        color
        fontWeight
        fontStyle
        borderColor
        borderWidth
        icon
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createThresholdMapping = /* GraphQL */ `
  mutation CreateThresholdMapping(
    $input: CreateThresholdMappingInput!
    $condition: ModelThresholdMappingConditionInput
  ) {
    createThresholdMapping(input: $input, condition: $condition) {
      id
      entityId
      extEntityId
      thresholdId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateThresholdMapping = /* GraphQL */ `
  mutation UpdateThresholdMapping(
    $input: UpdateThresholdMappingInput!
    $condition: ModelThresholdMappingConditionInput
  ) {
    updateThresholdMapping(input: $input, condition: $condition) {
      id
      entityId
      extEntityId
      thresholdId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteThresholdMapping = /* GraphQL */ `
  mutation DeleteThresholdMapping(
    $input: DeleteThresholdMappingInput!
    $condition: ModelThresholdMappingConditionInput
  ) {
    deleteThresholdMapping(input: $input, condition: $condition) {
      id
      entityId
      extEntityId
      thresholdId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createControlTable = /* GraphQL */ `
  mutation CreateControlTable(
    $input: CreateControlTableInput!
    $condition: ModelControlTableConditionInput
  ) {
    createControlTable(input: $input, condition: $condition) {
      taskId
      executionId
      jobDefinitionId
      clientId
      dataSource
      dataCategory
      sourceIdentifier
      timeRangeStart
      timeRangeEnd
      status
      recordsProcessed
      startTime
      endTime
      processingDuration
      errorDetails
      retryCount
      validationStatus
      validationDiscrepancies
      validationNotes
      priority
      lastUpdated
      createdBy
      version
      parentTaskId
      clientDataSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateControlTable = /* GraphQL */ `
  mutation UpdateControlTable(
    $input: UpdateControlTableInput!
    $condition: ModelControlTableConditionInput
  ) {
    updateControlTable(input: $input, condition: $condition) {
      taskId
      executionId
      jobDefinitionId
      clientId
      dataSource
      dataCategory
      sourceIdentifier
      timeRangeStart
      timeRangeEnd
      status
      recordsProcessed
      startTime
      endTime
      processingDuration
      errorDetails
      retryCount
      validationStatus
      validationDiscrepancies
      validationNotes
      priority
      lastUpdated
      createdBy
      version
      parentTaskId
      clientDataSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteControlTable = /* GraphQL */ `
  mutation DeleteControlTable(
    $input: DeleteControlTableInput!
    $condition: ModelControlTableConditionInput
  ) {
    deleteControlTable(input: $input, condition: $condition) {
      taskId
      executionId
      jobDefinitionId
      clientId
      dataSource
      dataCategory
      sourceIdentifier
      timeRangeStart
      timeRangeEnd
      status
      recordsProcessed
      startTime
      endTime
      processingDuration
      errorDetails
      retryCount
      validationStatus
      validationDiscrepancies
      validationNotes
      priority
      lastUpdated
      createdBy
      version
      parentTaskId
      clientDataSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createJobDefinition = /* GraphQL */ `
  mutation CreateJobDefinition(
    $input: CreateJobDefinitionInput!
    $condition: ModelJobDefinitionConditionInput
  ) {
    createJobDefinition(input: $input, condition: $condition) {
      jobDefinitionId
      name
      description
      clientId
      dataSource
      sourceEndpoint
      sourceFilters {
        name
        values
        __typename
      }
      dataTimeConfig {
        mode
        relativeValue
        relativeUnit
        offset
        startDateTime
        endDateTime
        granularity
        __typename
      }
      scheduleConfig {
        mode
        cronExpression
        timeZoneStrategy
        specificTimeZone
        scheduleStartDate
        scheduleEndDate
        scheduledTime
        __typename
      }
      status
      createdBy
      createdAt
      lastModified
      settings
      clientDataSource
      updatedAt
      __typename
    }
  }
`;
export const updateJobDefinition = /* GraphQL */ `
  mutation UpdateJobDefinition(
    $input: UpdateJobDefinitionInput!
    $condition: ModelJobDefinitionConditionInput
  ) {
    updateJobDefinition(input: $input, condition: $condition) {
      jobDefinitionId
      name
      description
      clientId
      dataSource
      sourceEndpoint
      sourceFilters {
        name
        values
        __typename
      }
      dataTimeConfig {
        mode
        relativeValue
        relativeUnit
        offset
        startDateTime
        endDateTime
        granularity
        __typename
      }
      scheduleConfig {
        mode
        cronExpression
        timeZoneStrategy
        specificTimeZone
        scheduleStartDate
        scheduleEndDate
        scheduledTime
        __typename
      }
      status
      createdBy
      createdAt
      lastModified
      settings
      clientDataSource
      updatedAt
      __typename
    }
  }
`;
export const deleteJobDefinition = /* GraphQL */ `
  mutation DeleteJobDefinition(
    $input: DeleteJobDefinitionInput!
    $condition: ModelJobDefinitionConditionInput
  ) {
    deleteJobDefinition(input: $input, condition: $condition) {
      jobDefinitionId
      name
      description
      clientId
      dataSource
      sourceEndpoint
      sourceFilters {
        name
        values
        __typename
      }
      dataTimeConfig {
        mode
        relativeValue
        relativeUnit
        offset
        startDateTime
        endDateTime
        granularity
        __typename
      }
      scheduleConfig {
        mode
        cronExpression
        timeZoneStrategy
        specificTimeZone
        scheduleStartDate
        scheduleEndDate
        scheduledTime
        __typename
      }
      status
      createdBy
      createdAt
      lastModified
      settings
      clientDataSource
      updatedAt
      __typename
    }
  }
`;
export const createJobExecution = /* GraphQL */ `
  mutation CreateJobExecution(
    $input: CreateJobExecutionInput!
    $condition: ModelJobExecutionConditionInput
  ) {
    createJobExecution(input: $input, condition: $condition) {
      executionId
      jobDefinitionId
      executionNumber
      clientId
      timeRangeStart
      timeRangeEnd
      status
      startTime
      endTime
      tasksTotal
      tasksSucceeded
      tasksFailed
      recordsProcessed
      triggeredBy
      lastUpdated
      errorSummary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateJobExecution = /* GraphQL */ `
  mutation UpdateJobExecution(
    $input: UpdateJobExecutionInput!
    $condition: ModelJobExecutionConditionInput
  ) {
    updateJobExecution(input: $input, condition: $condition) {
      executionId
      jobDefinitionId
      executionNumber
      clientId
      timeRangeStart
      timeRangeEnd
      status
      startTime
      endTime
      tasksTotal
      tasksSucceeded
      tasksFailed
      recordsProcessed
      triggeredBy
      lastUpdated
      errorSummary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteJobExecution = /* GraphQL */ `
  mutation DeleteJobExecution(
    $input: DeleteJobExecutionInput!
    $condition: ModelJobExecutionConditionInput
  ) {
    deleteJobExecution(input: $input, condition: $condition) {
      executionId
      jobDefinitionId
      executionNumber
      clientId
      timeRangeStart
      timeRangeEnd
      status
      startTime
      endTime
      tasksTotal
      tasksSucceeded
      tasksFailed
      recordsProcessed
      triggeredBy
      lastUpdated
      errorSummary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDemoBaseline = /* GraphQL */ `
  mutation CreateDemoBaseline(
    $input: CreateDemoBaselineInput!
    $condition: ModelDemoBaselineConditionInput
  ) {
    createDemoBaseline(input: $input, condition: $condition) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDemoBaseline = /* GraphQL */ `
  mutation UpdateDemoBaseline(
    $input: UpdateDemoBaselineInput!
    $condition: ModelDemoBaselineConditionInput
  ) {
    updateDemoBaseline(input: $input, condition: $condition) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDemoBaseline = /* GraphQL */ `
  mutation DeleteDemoBaseline(
    $input: DeleteDemoBaselineInput!
    $condition: ModelDemoBaselineConditionInput
  ) {
    deleteDemoBaseline(input: $input, condition: $condition) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDemoSeasonality = /* GraphQL */ `
  mutation CreateDemoSeasonality(
    $input: CreateDemoSeasonalityInput!
    $condition: ModelDemoSeasonalityConditionInput
  ) {
    createDemoSeasonality(input: $input, condition: $condition) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDemoSeasonality = /* GraphQL */ `
  mutation UpdateDemoSeasonality(
    $input: UpdateDemoSeasonalityInput!
    $condition: ModelDemoSeasonalityConditionInput
  ) {
    updateDemoSeasonality(input: $input, condition: $condition) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDemoSeasonality = /* GraphQL */ `
  mutation DeleteDemoSeasonality(
    $input: DeleteDemoSeasonalityInput!
    $condition: ModelDemoSeasonalityConditionInput
  ) {
    deleteDemoSeasonality(input: $input, condition: $condition) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDemoWeekdayProfile = /* GraphQL */ `
  mutation CreateDemoWeekdayProfile(
    $input: CreateDemoWeekdayProfileInput!
    $condition: ModelDemoWeekdayProfileConditionInput
  ) {
    createDemoWeekdayProfile(input: $input, condition: $condition) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDemoWeekdayProfile = /* GraphQL */ `
  mutation UpdateDemoWeekdayProfile(
    $input: UpdateDemoWeekdayProfileInput!
    $condition: ModelDemoWeekdayProfileConditionInput
  ) {
    updateDemoWeekdayProfile(input: $input, condition: $condition) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDemoWeekdayProfile = /* GraphQL */ `
  mutation DeleteDemoWeekdayProfile(
    $input: DeleteDemoWeekdayProfileInput!
    $condition: ModelDemoWeekdayProfileConditionInput
  ) {
    deleteDemoWeekdayProfile(input: $input, condition: $condition) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDemoUnitConfig = /* GraphQL */ `
  mutation CreateDemoUnitConfig(
    $input: CreateDemoUnitConfigInput!
    $condition: ModelDemoUnitConfigConditionInput
  ) {
    createDemoUnitConfig(input: $input, condition: $condition) {
      clientId
      entityId
      orgLevel
      salesMult
      avgCheckMult
      laborPctDelta
      wageMult
      seasonalityKey
      weekdayProfileKey
      throughputCap
      tags
      notes
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDemoUnitConfig = /* GraphQL */ `
  mutation UpdateDemoUnitConfig(
    $input: UpdateDemoUnitConfigInput!
    $condition: ModelDemoUnitConfigConditionInput
  ) {
    updateDemoUnitConfig(input: $input, condition: $condition) {
      clientId
      entityId
      orgLevel
      salesMult
      avgCheckMult
      laborPctDelta
      wageMult
      seasonalityKey
      weekdayProfileKey
      throughputCap
      tags
      notes
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDemoUnitConfig = /* GraphQL */ `
  mutation DeleteDemoUnitConfig(
    $input: DeleteDemoUnitConfigInput!
    $condition: ModelDemoUnitConfigConditionInput
  ) {
    deleteDemoUnitConfig(input: $input, condition: $condition) {
      clientId
      entityId
      orgLevel
      salesMult
      avgCheckMult
      laborPctDelta
      wageMult
      seasonalityKey
      weekdayProfileKey
      throughputCap
      tags
      notes
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDemoAtomicShiftDaily = /* GraphQL */ `
  mutation CreateDemoAtomicShiftDaily(
    $input: CreateDemoAtomicShiftDailyInput!
    $condition: ModelDemoAtomicShiftDailyConditionInput
  ) {
    createDemoAtomicShiftDaily(input: $input, condition: $condition) {
      clientId
      locationId
      date
      shift
      netSales
      checkCount
      fohDollars
      bohDollars
      fohHours
      bohHours
      splh
      laborPct
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDemoAtomicShiftDaily = /* GraphQL */ `
  mutation UpdateDemoAtomicShiftDaily(
    $input: UpdateDemoAtomicShiftDailyInput!
    $condition: ModelDemoAtomicShiftDailyConditionInput
  ) {
    updateDemoAtomicShiftDaily(input: $input, condition: $condition) {
      clientId
      locationId
      date
      shift
      netSales
      checkCount
      fohDollars
      bohDollars
      fohHours
      bohHours
      splh
      laborPct
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDemoAtomicShiftDaily = /* GraphQL */ `
  mutation DeleteDemoAtomicShiftDaily(
    $input: DeleteDemoAtomicShiftDailyInput!
    $condition: ModelDemoAtomicShiftDailyConditionInput
  ) {
    deleteDemoAtomicShiftDaily(input: $input, condition: $condition) {
      clientId
      locationId
      date
      shift
      netSales
      checkCount
      fohDollars
      bohDollars
      fohHours
      bohHours
      splh
      laborPct
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDemoRun = /* GraphQL */ `
  mutation CreateDemoRun(
    $input: CreateDemoRunInput!
    $condition: ModelDemoRunConditionInput
  ) {
    createDemoRun(input: $input, condition: $condition) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDemoRun = /* GraphQL */ `
  mutation UpdateDemoRun(
    $input: UpdateDemoRunInput!
    $condition: ModelDemoRunConditionInput
  ) {
    updateDemoRun(input: $input, condition: $condition) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDemoRun = /* GraphQL */ `
  mutation DeleteDemoRun(
    $input: DeleteDemoRunInput!
    $condition: ModelDemoRunConditionInput
  ) {
    deleteDemoRun(input: $input, condition: $condition) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
